import { ReactNode } from 'react'

import { useSaleTypes } from './useSaleTypes'
import SaleTypesDataContext from './SaleTypesDataContext'


type Props = {
  children: ReactNode
}

const SaleTypesData = ({ children }: Props) => {
  const value = useSaleTypes()

  return (
    <SaleTypesDataContext.Provider value={value}>
      {children}
    </SaleTypesDataContext.Provider>
  )
}

export default SaleTypesData
